
import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withCustomRouter,
  withTranslation,
  withTimeDependentName,
  withPersonNamesReason,
  withUserPreferences,
  withPersonalInfo,
} from 'components/hoc';
import MyDataContentTemplate from 'components/Dashboard/MyData/common/MyDataContentTemplate';
import LottieLoader from 'components/common/LottieLoader';

const defaultColumns = [
  {id: 'last_name', label: 'Last Name'},
  { id: '_reason', label: 'Reason'},
  { id: 'valid_from', label: 'Valid From' },
  { id: 'valid_to', label: 'Valid To' },
];

const filterableColumns = [
  { columnId: 'last_name', columnDataType: 'text', label: 'Last Name' },
  { columnId: 'valid_from', columnDataType: 'date', label: 'Valid From' },
  { columnId: 'valid_to', columnDataType: 'date', label: 'Valid To' },
  { columnId: 'reason', columnDataType: 'text', label: 'Reason' },
];

const TimeDependentName = (props) => {
  const { trObj, fd, getTimeDependentNames, routeParams, gotoCreatePath, gotoRoute } = props;
  const { personId } = routeParams;
  const [timeDependentName, setTimeDependentName] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const data = await getTimeDependentNames({ person_id: personId });
      setTimeDependentName(data || []);
      setLoaded(true);
    })();
  }, []);

  const mapFields = () => {
    return timeDependentName.map((data) => ({
      ...data,
      valid_from: fd(data.valid_from),
      valid_to: fd(data.valid_to),
      _reason: trObj(data.reason_detail),
    }));
  };

  if (!loaded) {
    return <LottieLoader />;
  }

  return (
    <MyDataContentTemplate
      tableName="time_dependent_name"
      columns={defaultColumns}
      data={mapFields()}
      toggleForm={gotoCreatePath}
      hasBulkDelete={false}
      filterableColumns={filterableColumns}
      hasGoBack
      handleGoBack={() => gotoRoute('/dashboard/data/base/person')}
    />
  );
};

export default compose(
  withCustomRouter,
  withTranslation,
  withTimeDependentName,
  withPersonNamesReason,
  withUserPreferences,
  withPersonalInfo,
)(TimeDependentName);



